// @flow
import React from 'react'
import './style.sass'
type Props = {
	title: string,
}
export default function OffScreenHeader({ title }: Props): React$Element<'h1'> {
	return <h1 className='OffScreen__Header'>{title}</h1>
}
